import MixPanelService from './MixPanelService'

class BottomNavigation {
    activeTab = null
    maptabsContainer = null
    mapTabsSelector = null
    mapTabsContent = null

    constructor() {}

    initialize() {
        this.maptabsContainer = document.getElementsByClassName('js-tabs-container')[0]
        this.mapTabsSelector = document.getElementsByClassName('js-map-bottom-tabs')[0]
        this.mapTabsContent = document.getElementsByClassName('js-tab-content')

        // Initial state where we hide all content of all tabs
        this.hideAllModuleContents()

        this.initEventListener()
    }

    initEventListener() {
        this.mapTabsSelector.addEventListener('click', event => {
            const tabClicked = event.target.dataset.tabname
            if (tabClicked !== undefined && tabClicked !== 'alerts') {
                if (this.activeTab !== null) {
                    // User clicked on the same (active) tab name, in this case close it 
                    this.activeTab = this.activeTab === tabClicked ? null : tabClicked
                    if (this.activeTab === null) {
                        this.hide()
                        document.querySelectorAll('.app-template').forEach((el) => { el.classList.remove('bottom-tabs-open') })
                    } else {
                        this.hideAllModuleContents()
                        document.querySelectorAll('.js-map-tab').forEach((el) => { el.classList.remove('is-active') })
                        document.querySelectorAll('.app-template').forEach((el) => { el.classList.add('bottom-tabs-open') })
                        this.open(tabClicked)
                    }
                } else {
                    this.hideAllModuleContents()
                    this.activeTab = tabClicked
                    document.querySelectorAll('.app-template').forEach((el) => { el.classList.add('bottom-tabs-open') })
                    this.open(tabClicked)
                }
            }
        })
    }

    hideAllModuleContents() {
        this.mapTabsContent.forEach(tabContent => tabContent.style.display = 'none')
    }

    open(tabName) {
            const tabNameMapper = {
                'my-fleet': 'My Fleet',
                'my-airports': 'My Airports',
                'my-routes': 'My Routes'
            }
            MixPanelService.track(`Tab View - ${tabNameMapper[tabName]}`)
            this.maptabsContainer.classList.add('is-expanded')
            document.querySelector('[data-tabname="' + tabName + '"]').classList.add('is-active')
            document.querySelector('[data-tab="' + tabName + '"]').style.display = 'block' 
    }

    hide() {
        this.activeTab = null
        document.querySelectorAll('.js-map-tab').forEach((el) => { el.classList.remove('is-active') })
        this.maptabsContainer.classList.remove('is-expanded')
        document.querySelectorAll('.app-template').forEach((el) => { el.classList.remove('bottom-tabs-open') })
    }
}

const BottomNavigationService = new BottomNavigation()

export default BottomNavigationService